"use client";

import React, { useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

const values = [
  {
    icon: 'ShieldCheckIcon',
    title: '品質為先',
    titleEn: 'Quality First',
    desc: '嚴格執行國際品質標準，每批產品出廠前均經過多道品控檢驗，確保每一件商品達到合作夥伴的期望。',
  },
  {
    icon: 'TruckIcon',
    title: '快速響應',
    titleEn: 'Fast Response',
    desc: '24小時出貨響應機制，上海倉儲直發全國，讓您的庫存永遠不空缺，業務永遠不停擺。',
  },
  {
    icon: 'HandshakeIcon',
    title: '誠信合作',
    titleEn: 'Integrity',
    desc: '十餘年誠信經營，每一份合同都是承諾。透明的定價體系，無隱藏費用，讓合作更簡單。',
    iconFallback: 'UserGroupIcon',
  },
  {
    icon: 'LightBulbIcon',
    title: '持續創新',
    titleEn: 'Innovation',
    desc: '緊跟市場趨勢，每季度更新產品結構，為合作夥伴持續引入有競爭力的新品，保持市場領先。',
  },
];

export default function ValuesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { if (e.isIntersecting) e.target.classList.remove('reveal-hidden'); });
      },
      { threshold: 0.1 }
    );
    sectionRef.current?.querySelectorAll('.reveal').forEach((el) => {
      el.classList.add('reveal-hidden');
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 px-6" style={{ background: '#F5EFE6' }}>
      <div className="max-w-container mx-auto">
        <div className="text-center mb-14 reveal">
          <p className="text-xs font-semibold tracking-widest uppercase text-accent mb-2">
            OUR VALUES · 核心價值觀
          </p>
          <h2 className="font-heading font-bold text-brand-fg" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
            信悅的承諾
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v, i) => (
            <div
              key={v.title}
              className="reveal bg-white rounded-3xl p-7 border border-brand-border hover:border-primary/30 hover:shadow-card transition-all duration-300 group"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div
                className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300"
                style={{ background: 'linear-gradient(135deg, #F5EFE6, #EDE4D8)' }}
              >
                <Icon name={v.icon as any} size={24} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-brand-fg text-lg mb-1">{v.title}</h3>
              <p className="text-xs text-accent mb-3">{v.titleEn}</p>
              <p className="text-sm text-brand-muted leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}